export const ORE_EMAIL = "tools.pheiti@dof.gov.ph"; //ore.ph.site@gmail.com


// WEBPACK FOOTER //
// ./src/constants/ContactData.js